<span [@fadeScrollButton]="scrollPossible" class="bottom-right" (click)="mainService.scrollToTop()"><i class="fas fa-3x fa-chevron-circle-up"></i></span>